import React from 'react';
import { ServiceIncludesItem, ServiceIncludesList, ServiceTvDetails } from '../styled';
var IncludesList = function (_a) {
    var tvDescriptions = _a.tvDescriptions, openPopup = _a.openPopup;
    return (<ServiceIncludesList>
            {tvDescriptions.map(function (desc, index) { return (<ServiceIncludesItem key={index} withDetails={!!desc.details} data-test='includes-item'>
                    <div dangerouslySetInnerHTML={{ __html: desc.desc }}/>
                    {desc.details &&
                <ServiceTvDetails onClick={openPopup} data-test='popup-link'>
                            {desc.details}
                        </ServiceTvDetails>}
                </ServiceIncludesItem>); })}
        </ServiceIncludesList>);
};
export default IncludesList;
